import { format, sub } from "date-fns";

const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const getMonth = (date) => {
  const lastMonths = [];
  for (let i = 0; i < 12; i += 1) {
    lastMonths.push(monthNames[date.getMonth()]);
    date.setMonth(date.getMonth() + 1);
    if (i === 11) lastMonths.push(monthNames[date.getMonth()]);
  }
  return lastMonths;
};

export const getCurrentMonth = (backYear = 0, backMonth = 0) => {
  const date = new Date();
  return `${date.getFullYear() - backYear}-${`0${date.getMonth() + 1 - backMonth}`.slice(-2)}`;
};

export const getCurrentMonthWithDay = (backYear = 0) => {
  const date = new Date();
  return `${date.getFullYear() - backYear}-${`0${date.getMonth() + 1}`.slice(
    -2
  )}-${`0${date.getDate()}`.slice(-2)}`;
};

export const monthFormater = (date, symbol = "-") => {
  return `${date.getFullYear()}${symbol}${`0${date.getMonth() + 1}`.slice(-2)}`;
};

export const monthDayFormater = (date) => {
  return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(
    -2
  )}-${`0${date.getDate()}`.slice(-2)}`;
};
export const monthDayNameFormater = (date) => {
  return `${`0${date.getDate()}`.slice(-2)} ${`${
    monthNames[date.getMonth()]
  }`} ${date.getFullYear()}`;
};

export const compareTwoMonth = (date) => {
  const currentDate = new Date();
  return currentDate.getMonth() - date.getMonth();
};

export const getLastMonths = (date, monthLength) => {
  const lastMonths = [];
  for (let i = 0; i < monthLength; i += 1) {
    lastMonths[i] = `${date.getFullYear().toString()}-${`0${date.getMonth() + 1}`.slice(-2)}`;
    date.setMonth(date.getMonth() - 1);
  }

  return lastMonths;
};

export const getFromToLastXDays = (numberOfDays, dateFormat = "") => {
  const yesterday = sub(new Date(), { days: 1 });
  const xDaysFromYesterday = sub(yesterday, { days: numberOfDays });
  return {
    to: dateFormat ? format(yesterday, dateFormat) : yesterday,
    from: dateFormat ? format(xDaysFromYesterday, dateFormat) : xDaysFromYesterday,
  };
};

export const getFromToLastXDaysIncludingToday = (numberOfDays, dateFormat = "") => {
  const today = new Date();
  const xDaysFromToday = sub(today, { days: numberOfDays });
  return {
    to: dateFormat ? format(today, dateFormat) : today,
    from: dateFormat ? format(xDaysFromToday, dateFormat) : xDaysFromToday,
  };
};

/**
 * Format date range for display as subtitle
 * @param {string|Date} from - Start date (YYYY-MM-DD format or Date object)
 * @param {string|Date} to - End date (YYYY-MM-DD format or Date object)
 * @returns {string} Formatted date range string like "(up to 25 Jan)"
 */
export const formatDateRangeSubtitle = (from, to) => {
  if (!to) return "";
  try {
    const toDate = typeof to === "string" ? new Date(to) : to;
    const formattedTo = format(toDate, "dd MMM");
    return `(up to ${formattedTo})`;
  } catch {
    return "";
  }
};

/**
 * Format date range for tooltip explanation
 * @param {string|Date} from - Start date (YYYY-MM-DD format or Date object)
 * @param {string|Date} to - End date (YYYY-MM-DD format or Date object)
 * @returns {string} Formatted tooltip text like "Data from 01 Jan to 25 Jan, latest transaction may not be included/categorized yet"
 */
export const formatDateRangeTooltip = (from, to) => {
  if (!from || !to) return "";
  try {
    const fromDate = typeof from === "string" ? new Date(from) : from;
    const toDate = typeof to === "string" ? new Date(to) : to;
    const formattedFrom = format(fromDate, "dd MMM");
    const formattedTo = format(toDate, "dd MMM");
    return `Data from ${formattedFrom} to ${formattedTo}, latest transactions may not be included/categorized yet`;
  } catch {
    return "";
  }
};
